export default __webpack_public_path__ + "static/media/04_photo.0f8fcda1.jpg";